import { j as e } from "./jsx-runtime.BREq8dyb.js";
import { useBoolean as De } from "@decentriq/hooks";
import { faICursor as We, faCheck as ze, faXmark as Ee } from "@fortawesome/pro-light-svg-icons";
import { faExclamationSquare as Le } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon as oe } from "@fortawesome/react-fontawesome";
import { Button as Ne, styled as L, Alert as qe, Tooltip as x, CircularProgress as Be, Box as z, Skeleton as Fe, Input as He } from "@mui/joy";
import { memo as se, forwardRef as ae, useState as E, useCallback as a, useMemo as ie, useEffect as Oe, useRef as Me } from "react";
import { i as Ge } from "./react-click-away-listener.BrTEM9EK.js";
import { N as Je } from "./slate.CkrhgTOe.js";
import Ke from "./components/DqInlineEditor/components/Content/Content.js";
import re from "./components/DqInlineEditor/components/FormattedInput/FormattedInput.js";
const v = (t) => {
  if (typeof t == "string")
    try {
      const r = JSON.parse(t);
      return r === null ? "" : Array.isArray(r) ? r : typeof r == "object" ? "" : r.toString() || "";
    } catch {
      return t;
    }
  else
    return "";
}, Pe = (t) => typeof t == "string" ? t : JSON.stringify(t), Te = (t, r) => {
  const s = r?.skipDeserialization ? t : v(t);
  return typeof s == "string" ? s.trim().length === 0 : Array.isArray(s) ? s.map((n) => Je.string(n)).join(`
`).trim().length === 0 : !s;
}, le = se(ae(({
  className: t,
  icon: r,
  onClick: s,
  color: n = "neutral",
  style: c,
  ...S
}, I) => /* @__PURE__ */ e.jsx(Ne, { className: t, color: n, onClick: s, ref: I, style: c, ...S, children: /* @__PURE__ */ e.jsx(oe, { fixedWidth: !0, icon: r }) })));
le.displayName = "DqInlineEditorButton";
const j = L(le)(({
  theme: t
}) => ({
  borderRadius: t.radius.xs,
  display: "flex",
  fontSize: "1rem",
  margin: 0,
  minHeight: "auto",
  minWidth: "auto",
  padding: t.spacing(0.5)
}));
j.displayName = "StyledDqInlineEditorButton";
const Xe = L(qe)(({
  theme: t
}) => ({
  "& .MuiAlert-startDecorator": {
    fontSize: "1em",
    marginRight: 0,
    padding: 1
  },
  "&.MuiAlert-root": {
    "&:empty": {
      display: "none"
    },
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: 1,
    padding: 2,
    whiteSpace: "nowrap"
  },
  padding: t.spacing(0.5)
})), de = se(ae(({
  className: t = void 0,
  style: r = {},
  sx: s = {},
  loading: n = !1,
  readOnly: c = !1,
  withFormatting: S = !1,
  startAdornment: I = null,
  endAdornment: ce = null,
  startEditingButtonEnabled: pe = !1,
  startEditingButtonIcon: fe = We,
  startEditingButtonTooltipPlacement: ue = "top",
  startEditingButtonTooltipTitle: ge = "Edit",
  startEditingOnContentClick: N = !0,
  cancelEditingButtonEnabled: q = !0,
  cancelEditingButtonIcon: B = Ee,
  cancelEditingButtonTooltipTitle: F = /* @__PURE__ */ e.jsxs("div", { style: {
    display: "flex"
  }, children: [
    /* @__PURE__ */ e.jsx("div", { style: {
      marginRight: "0.5rem"
    }, children: "Cancel" }),
    /* @__PURE__ */ e.jsx("div", { style: {
      opacity: 0.75
    }, children: "Esc" })
  ] }),
  cancelEditingButtonTooltipPlacement: H = "bottom-end",
  saveEditingButtonEnabled: O = !0,
  saveEditingButtonIcon: M = ze,
  saveEditingButtonTooltipTitle: G = /* @__PURE__ */ e.jsxs("div", { style: {
    display: "flex"
  }, children: [
    /* @__PURE__ */ e.jsx("div", { style: {
      marginRight: "0.5rem"
    }, children: "Save" }),
    /* @__PURE__ */ e.jsx("div", { style: {
      opacity: 0.75
    }, children: "Return" })
  ] }),
  saveEditingButtonTooltipPlacement: J = "bottom-end",
  saveEditingOnClickAway: K = !1,
  validate: b = void 0,
  validationErrorTooltipPlacement: P = "top",
  value: l,
  placeholder: k = void 0,
  onChange: C = void 0,
  StartEditingButtonProps: me = void 0,
  SaveEditingButtonProps: T = void 0,
  CancelEditingButtonProps: X = void 0,
  ContentProps: ye = void 0,
  FormattedInputProps: Q = void 0,
  InputProps: he = void 0,
  PlaceholderProps: xe = void 0,
  dataTestid: ve = void 0,
  helperTestid: U = void 0
}, Y) => {
  const [p, w] = E(void 0), [o, m] = E(v(l)), je = Array.isArray(o) ? o : typeof o == "string" ? [{
    children: [{
      text: o
    }],
    type: "paragraph"
  }] : void 0, Se = !!o, Z = Array.isArray(o), _ = Te(o, {
    skipDeserialization: !0
  }), g = c || typeof C != "function", [A, {
    setTrue: R,
    setFalse: y
  }] = De(!1), [d, D] = E(!1), h = a(() => Promise.resolve(y()), [y]), $ = a((i) => (D(!0), Promise.resolve(C?.(Pe(i))).then(() => {
    D(!1), y();
  }).catch(() => {
    D(!1);
  })), [y, C]), f = a(() => {
    p || (o === l ? h() : $(o));
  }, [l, h, $, p, o]), u = a(() => {
    m(v(l)), w(void 0), h();
  }, [h, l]), Ie = (i) => m(i), be = a((i) => {
    m(i.target.value), typeof b == "function" && (l !== i.target.value ? w(b(i.target.value)) : w(void 0));
  }, [b, l]), ke = a((i) => {
    i.stopPropagation(), d || (i.key === "Enter" ? f() : i.key === "Escape" && u());
  }, [d, u, f]), Ce = a((i) => {
    A && !d && (K ? f() : u());
  }, [A, d, u, f, K]), we = a(() => {
    !g && N && R();
  }, [g, R, N]), V = a((i) => {
    i.stopPropagation(), f();
  }, [f]), ee = a((i) => {
    i.stopPropagation(), u();
  }, [u]), Ae = !g && pe ? /* @__PURE__ */ e.jsx(x, { disableFocusListener: !0, disableTouchListener: !0, placement: ue, title: ge, children: /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(j, { icon: fe, onClick: R, ...me }) }) }) : null, te = ie(() => [O ? /* @__PURE__ */ e.jsx(x, { disableFocusListener: !0, disableTouchListener: !0, placement: J, title: G, children: /* @__PURE__ */ e.jsx(j, { icon: M, onClick: V, ...T }) }, "save") : null, q ? /* @__PURE__ */ e.jsx(x, { disableFocusListener: !0, disableTouchListener: !0, placement: H, title: F, children: /* @__PURE__ */ e.jsx(j, { icon: B, onClick: ee, ...X }) }, "cancel") : null].filter(Boolean), [X, T, q, B, H, F, ee, V, O, M, J, G]), ne = ie(() => /* @__PURE__ */ e.jsx("div", { className: "endAdornmentWrapper", children: d ? /* @__PURE__ */ e.jsx(Be, { sx: {
    "--CircularProgress-size": "1rem",
    flex: "0 0 auto",
    margin: "0.25rem"
  } }) : p ? /* @__PURE__ */ e.jsx(x, { disableFocusListener: !0, disableTouchListener: !0, placement: P, title: p, children: /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(Xe, { color: "danger", startDecorator: /* @__PURE__ */ e.jsx(oe, { fixedWidth: !0, icon: Le }) }) }) }) : te }), [te, d, p, P]);
  Oe(() => m(v(l)), [l]);
  const W = Me(null), Re = a((i) => {
    i && W?.current && W.current.checkOverflowingChildren();
  }, []);
  return n ? /* @__PURE__ */ e.jsx(z, { style: r, sx: s, children: /* @__PURE__ */ e.jsx(Fe, { animation: "wave", height: 24, variant: "rectangular", width: "100%" }) }) : g && _ ? null : /* @__PURE__ */ e.jsx(Ge, { onClickAway: Ce, children: /* @__PURE__ */ e.jsx(z, { className: t, style: r, sx: s, children: g || !A ? /* @__PURE__ */ e.jsx(Ke, { actions: Ae, dataTestid: U, endAdornment: ce, onClick: we, ref: W, startAdornment: I, ...ye, children: Se && !_ ? Z ? /* @__PURE__ */ e.jsx(re, { readOnly: !0, ref: Re, value: o, ...Q }) : o : /* @__PURE__ */ e.jsx(z, { "data-testid": U, ...xe, children: k }) }) : Z || S ? /* @__PURE__ */ e.jsx(re, { endAdornment: ne, onChange: Ie, placeholder: k, readOnly: d, ref: Y, value: je, ...Q }) : /* @__PURE__ */ e.jsx(He, { autoFocus: !0, className: "contentInput", endDecorator: ne, error: !!p, onChange: be, onKeyDown: ke, placeholder: k, readOnly: d, ref: Y, slotProps: {
    input: {
      "data-testid": ve,
      size: o.length,
      style: {
        fieldSizing: "content"
      }
    }
  }, sx: {
    "--Input-gap": 0,
    "--Input-minHeight": "auto"
  }, value: o, variant: "plain", ...he }) }) });
}));
de.displayName = "DqInlineEditor";
const Qe = L(de)(({
  readOnly: t = !1,
  fullWidth: r = !1,
  onChange: s
}) => ({
  theme: n
}) => {
  const c = t || typeof s != "function";
  return {
    "& .actionsWrapper": {
      "&:empty": {
        display: "none"
      },
      alignSelf: "flex-start",
      display: "flex",
      flexBasis: "auto",
      flexGrow: 0,
      flexShrink: 0,
      justifyContent: "flex-end",
      marginLeft: n.spacing(0.5),
      opacity: 0,
      transition: "all 0.2s linear"
    },
    "& .content": {
      "&::-webkit-scrollbar": {
        display: "none"
      },
      cursor: c ? "default" : "text",
      display: "flex",
      flexBasis: "inherit",
      flexGrow: 1,
      flexShrink: 1,
      fontWeight: "inherit",
      maskImage: "var(--mask-image)",
      maxHeight: "var(--max-height)",
      overflow: "auto",
      paddingRight: "var(--padding-right)",
      whiteSpace: "var(--white-space)"
    },
    "& .contentInput": {
      "& .MuiInputBase-input": {
        "&:not(:last-child)": {
          marginRight: n.spacing(0.5)
        },
        height: "auto",
        lineHeight: "inherit",
        padding: 0
      },
      "& .endAdornmentWrapper": {
        alignItems: "center",
        display: "flex",
        gridArea: "1/2"
      },
      borderRadius: n.radius.sm,
      flex: 1,
      fontSize: "inherit",
      fontWeight: "inherit",
      lineHeight: "inherit",
      margin: n.spacing(-0.5),
      padding: n.spacing(0.5),
      transition: "all 0.2s linear"
    },
    "& .contentWrapper": {
      alignSelf: "stretch",
      display: "flex",
      flexBasis: r ? "100%" : "auto",
      flexGrow: 0,
      flexShrink: 1,
      overflow: "auto"
      // 👀
    },
    "& .endAdornmentWrapper": {
      "&:not(:empty)": {
        marginLeft: n.spacing(0.5)
      },
      alignItems: "baseline",
      display: "flex"
    },
    "& .fullHeightToggleButtonWrapper": {
      "&:empty": {
        display: "none"
      },
      bottom: 0,
      display: "flex",
      height: n.spacing(0.5),
      left: 0,
      opacity: 0,
      position: "absolute",
      transition: "all 0.2s linear",
      width: "100%",
      zIndex: 1
    },
    "& .startAdornmentWrapper": {
      "&:not(:empty)": {
        marginRight: n.spacing(0.5)
      },
      alignItems: "baseline",
      display: "flex"
    },
    "&:hover": !c && {
      backgroundColor: n.palette.neutral[50]
    },
    "&:hover .actionsWrapper": {
      opacity: 1
    },
    "&:hover .fullHeightToggleButtonWrapper": {
      opacity: 1
    },
    alignItems: "baseline",
    backgroundColor: "transparent",
    borderRadius: n.radius.sm,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    margin: n.spacing(-0.5),
    overflow: "hidden",
    padding: n.spacing(0.5),
    position: "relative",
    transition: "all 0.2s linear"
  };
});
Qe.displayName = "StyledDqInlineEditor";
export {
  Qe as S,
  Te as i
};
//# sourceMappingURL=DqInlineEditor.BguPN4Ku.js.map
